export const EXPERIMENTS = {
    FOXES_BRIEFS_NEW_BUYER_OVERVIEW: 4139,
    CROWS_MP_BFF_EXPANSION: 5159,
    CROWS_AGENTIC_JOB_POST: 5188,
    MIRA_ENTRY_POINTS_V1: 5263,
};
